import React, { useEffect, useState } from "react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import SnackBarMessage from "../../components/SnackBarMessage";
import { Button, Grid, InputLabel, TextField, CircularProgress, Avatar, MenuItem } from '@mui/material';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImagesDefault from "../../assets/imagesDefault";
import { addItem, updateItem } from "../repositories/FoundationRepository";

const FoundationForm = ({ item, isEditing, add, statusData }) => {

    const [buttonText, setButtonText] = useState("Guardar");
    const [loading, setLoading] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("success");
    const [snackMessage, setSnackMessage] = useState("");
    const [avatarImage, setAvatarImage] = useState(null)

    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: item?.name || '',
            city: item?.city || '',
            typeOfFoundation: item?.typeOfFoundation || '',
            logo: item?.logo || '',
            status: statusData[0]?.name || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required('Campo obligatorio'),
            city: Yup.string().required('Campo obligatorio'),
            typeOfFoundation: Yup.string().required('Campo obligatorio')
        }),
        onSubmit: async () => {
            const exist = item?._id || null;
            setLoading(true)

            let actionResponse = null;
            if (exist) {
                actionResponse = await updateFoundation();
            } else {
                actionResponse = await createNewFoundation();
            }
            setLoading(false)
            if (actionResponse) {
                setSnackSeverity("success");
                setSnackMessage("Operación exitosa");
                setSnackOpen(true);
            } else {
                setSnackSeverity("error");
                setSnackMessage("Error en la operación");
                setSnackOpen(true);
            }
        },
    });

    const createNewFoundation = async () => {
        let newObject = {
            name: formik.values.name,
            city: formik.values.city,
            typeOfFoundation: formik.values.typeOfFoundation,
            logo: formik.values.logo
        }

        const response = await addItem(newObject)
        return response;
    }

    const updateFoundation = async () => {
        let newObject = {
            name: formik.values.name,
            city: formik.values.city,
            typeOfFoundation: formik.values.typeOfFoundation,
            logo: formik.values.logo,
            status: formik.values.status
        }

        const response = await updateItem(newObject, item._id)
        return response;
    }

    useEffect(() => {
        formik.setFieldValue('status', item && item.status ? item.status : "Activo");
        if (item) {
            setAvatarImage(item?.logo?.url)
        }
    }, []);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}
                style={{
                    height: "50vh",
                    marginTop: "16px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                }}>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            marginBottom: "15px",
                        }}
                    >
                        <Avatar
                            alt="Foundation Logo"
                            src={
                                avatarImage !== null ? avatarImage : ImagesDefault.DogAvatar
                            }
                            sx={{ width: 120, height: 120 }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            marginBottom: "15px",
                        }}
                    >
                        <input type="file" id="inputImage" style={{ display: "none" }} />

                        <Button
                            id="button-style-image-user-form"
                            sise="small"
                            variant="contained"
                            fullWidth
                            disabled={isEditing}
                            onClick={() => {
                                document.getElementById("inputImage").click();
                                document.getElementById("inputImage").onchange = (e) => {
                                    formik.setFieldValue(
                                        "logo",
                                        document.getElementById("inputImage").files[0]
                                    );
                                    setAvatarImage(
                                        URL.createObjectURL(
                                            document.getElementById("inputImage").files[0]
                                        )
                                    );
                                };
                            }}
                        >
                            <CloudUploadIcon
                                style={{ marginRight: "5px", paddingBottom: "3px" }}
                            />
                            Cargar imagen
                        </Button>
                    </div>
                </Grid>
                <Grid
                    item
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    style={{ marginTop: "2px" }}
                >
                    <InputLabel shrink>Nombre</InputLabel>
                    <TextField
                        type="text"
                        id="name"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        disabled={isEditing}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginTop: "2px" }}
                >
                    <InputLabel shrink>Ciudad</InputLabel>
                    <TextField
                        type="text"
                        id="city"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        disabled={isEditing}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        fullWidth
                        error={formik.touched.city && Boolean(formik.errors.city)}
                        helperText={formik.touched.city && formik.errors.city}
                    />
                </Grid>
                <Grid
                    item
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginTop: "2px" }}
                >
                    <InputLabel shrink>Tipo de Fundación</InputLabel>
                    <TextField
                        type="text"
                        id="typeOfFoundation"
                        name="typeOfFoundation"
                        value={formik.values.typeOfFoundation}
                        onChange={formik.handleChange}
                        disabled={isEditing}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        fullWidth
                        error={formik.touched.typeOfFoundation && Boolean(formik.errors.typeOfFoundation)}
                        helperText={formik.touched.typeOfFoundation && formik.errors.typeOfFoundation}
                    />
                </Grid>
                <Grid
                    item
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginTop: "2px" }}
                >
                    <InputLabel shrink>Estatus</InputLabel>
                    <TextField
                        select
                        id="status"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={add}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        fullWidth
                    >
                        {statusData.map((item) => (
                            <MenuItem key={item.id} value={item.name}>
                                {item.name}
                            </MenuItem>
                        ))}

                    </TextField>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <Button
                            id="button-style-save-reception-form"
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!formik.dirty}
                        >
                            {buttonText}
                        </Button>
                    )}
                </Grid>
            </Grid>

            <SnackBarMessage
                open={snackOpen}
                severity={snackSeverity}
                message={snackMessage}
                setOpen={setSnackOpen}
                onClose={handleSnackClose}
            />
        </form >
    );
};

export default FoundationForm;